import moment from 'moment';

export type DateOption = {
  value: string;
  label: string;
};

export function generateDateOptions(
  startDate: string | undefined,
  count: number
): DateOption[] {
  if (!startDate) return [];

  const result: DateOption[] = [];

  for (let i = 0; i < count; i++) {
    const date = moment(startDate).add(i, 'days');
    result.push({
      value: date.format('YYYY-MM-DD'),
      label: date.format('dddd, MMMM Do'),
    });
  }

  return result;
}
